module.exports = __webpack_public_path__ + "static/media/volume-control.0db457bd.svg";